<template>
    <component
        :is="as ?? 'button'"
        class="cz2__red-banner-button"
        :class="headerFontClass"
        :disabled="disabled"
    >
        <h1
            class="cz2__red-banner-button__content"
        >
            <slot />
        </h1>
    </component>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    #cz2.cz2 {
        .cz2__red-banner-button {
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
            outline: none;
            padding: 0px 16px;

            width: 100%;

            position: relative;

            display: flex;
            justify-content: center;
            text-transform: uppercase;
            font-style: italic;
            color: color(primaryWhite);

            &:disabled {
                cursor: not-allowed;
            }

            font-size: 32px;
            @include respond-above(xl) {
                font-size: 50px;
            }

            .cz2__red-banner-button__content {
                position: relative;

                display: flex;
            }

            &:before {
                position: absolute;
                left: -8px;

                width: 110%;
                height: 100%;
                content: '';
                clip-path: polygon(0 0, 98% 8%, 94% 90%, 2% 100%);
                background-color: color(v2Red);
            }
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__red-banner-button {
            &:before {
                background-color: color(knicksYellow);
            }

            color: black;
            font-style: normal;
        }
    }
</style>

<script>
    export default {
        props: {
            as: String,
            disabled: Boolean,
        },

        computed: {
            headerFontClass() {
                return this.$store.getters.headerFontClass;
            },
        },
    };
</script>
